import React, { useContext } from "react";
import { observer } from "mobx-react";

import { MyBetsBetContext } from "@state/context/my-bets/MyBetsBetContext";
import BetCardBody from "./BetCardBody";

import { MyBetsStoreContext } from "@state/context/my-bets/MyBetsStoreContext";
import MyBetsStore from "@state/stores/my-bets/MyBetsStore";
import BetCardLinkHeader from "./BetCardLinkHeader";

export default observer(function BetCardLink() {
	const bet = useContext(MyBetsBetContext);
	const myBetsStore = useContext(MyBetsStoreContext);

	if (!(myBetsStore instanceof MyBetsStore)) {
		return null;
	}

	return (
		<div
			onClick={() =>
				myBetsStore.betDetailsModalStore.openModal(
					bet,
					myBetsStore.walletId || ""
				)
			}
		>
			<BetCardLinkHeader />
			<BetCardBody />
		</div>
	);
});
